import styled from 'styled-components';
import { getSpacingToken, IconName, Position, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TooltippedIconButton } from '@mews-commander/ui';

interface LockableFieldProps {
    locked: boolean;
    lockable: boolean;
    tooltipTextKey: Mews.TextKey;
    children: React.ReactNode;
    onLockToggle: () => void;
}

const PositionedButton = styled(TooltippedIconButton)`
    margin-top: ${getSpacingToken('300')}px;
`;

export const LockableField = ({ locked, tooltipTextKey, children, lockable, onLockToggle }: LockableFieldProps) => (
    <>
        {lockable ? (
            <Stack spacing="100" distribution="space-between" alignment="end">
                <StackItem grow>{children}</StackItem>
                <PositionedButton
                    icon={locked ? IconName.Lock : IconName.Unlock}
                    size="small"
                    tooltip={<LocalizedText textKey={tooltipTextKey} />}
                    tooltipPosition={Position.Bottom}
                    onClick={onLockToggle}
                    type="button"
                />
            </Stack>
        ) : (
            <>{children}</>
        )}
    </>
);
